import { useNavigate } from '@tanstack/react-router';

import { Button } from '../cdl/Button/Button';
import { Text } from '../cdl/Text/Text';
import { ButtonGroup } from '../common/buttons/ButtonGroup';
import { translate } from '../common/helpers/translate.helper';
import { useOpenFreshchat } from '../common/hooks/useOpenFreshchat';
import { Box } from '../common/ui/Box';
import { theme } from '../common/ui/theme';

export const InactiveUserError = () => {
    const navigate = useNavigate();
    const openFreshchat = useOpenFreshchat();

    const handleContactSupport = () => {
        openFreshchat();
    };

    const handleLoginWithAnother = () => {
        navigate({ to: '/logout' });
    };

    return (
        <Box display="flex" justifyContent="center" paddingTop="256px">
            <Box display="grid" gap={theme.space[32]} width="560px">
                <Box display="grid" gap={theme.space[16]}>
                    <Text variant="display">{translate('authentication.inactiveUser.headline')}</Text>
                    <Text variant="body" color={theme.colors.foreground.muted}>
                        {translate('authentication.inactiveUser.message')}
                    </Text>
                    <Text variant="body" color={theme.colors.foreground.muted}>
                        {translate('authentication.inactiveUser.signInAgain')}
                    </Text>
                </Box>

                <ButtonGroup>
                    <Button emphasis="high" onClick={handleContactSupport}>
                        {translate('authentication.inactiveUser.contactSupport')}
                    </Button>
                    <Button onClick={handleLoginWithAnother}>
                        {translate('authentication.inactiveUser.backToSignIn')}
                    </Button>
                </ButtonGroup>
            </Box>
        </Box>
    );
};
